import Vue from 'vue';

// * PROGRESSBAR MIXIN
import progressBar_mixin from '@/components/progressBar/progressBar_mixin.js';
Vue.use(progressBar_mixin);